import React from 'react';
import { Button, ButtonSize, ButtonType } from '@ids/react-button';

const PrimaryButton = ({ text, onClickEvent, disabled = false, isSmall = false }) => {
  return (
    <Button
      size={isSmall ? ButtonSize.SMALL : ButtonSize.MEDIUM}
      type={ButtonType.FILLED}
      onClick={onClickEvent}
      disabled={disabled}>
      {text}
    </Button>
  );
};

export default PrimaryButton;
